export default __webpack_public_path__ + "flutter-ios@2x.png";